const o = {
  name: "Thailand",
  dimensions: { width: 16, height: 21 },
  content: `
    <g>
      <path d="M11.54 14.8632C11.54 14.6254 11.51 14.4416 11.48 14.2794C11.18 12.7551 9.76 11.5875 8.04 11.5875C6.32 11.5875 4.9 12.7443 4.6 14.2794C4.56 14.4416 4.54 14.6362 4.54 14.8632C4.53 17.9443 2 19.5875 2 19.5875H8.03H14C14 19.5875 11.54 17.9443 11.54 14.8632Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1 19.5875H15" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 11.5875V7.7386C6 7.10911 6.56858 6.58752 7.27681 6.58752H8.72319C9.42145 6.58752 10 7.10011 10 7.7386V11.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 1.58752V6.58752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Thailand
};
